import { MEETING_RULES } from '../../types'

export default function MeetingRules() {
  return (
    <div className="bg-white rounded-lg shadow-card border-l-4 border-pinnacle-red p-6">
      <h4 className="text-sm font-bold uppercase tracking-widest text-text-primary mb-4">Meeting Rules</h4>
      <ol className="space-y-3">
        {MEETING_RULES.map((rule, index) => (
          <li key={index} className="flex items-start gap-3">
            <span className="flex-shrink-0 w-7 h-7 rounded-full bg-pinnacle-red/10 text-pinnacle-red flex items-center justify-center text-sm font-semibold">
              {index + 1}
            </span>
            <span className="text-base text-text-primary leading-relaxed pt-0.5">{rule}</span>
          </li>
        ))}
      </ol>
    </div>
  )
}
